import React, { useEffect, useState } from 'react';
import Layout from '../../../Layout';
// import EmptyComponentLink from '../../../components/EmptyComponent/EmptyComponentLink';
import { CopyOutlined, DeleteOutlined, EditOutlined, EyeOutlined, PlusCircleOutlined } from '@ant-design/icons';
import { Breadcrumb, ConfigProvider, DatePicker, Input } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import * as RankApi from '../../../api/rank/rankApi';
import { NO_DATA, URL_RANK } from '../../../env';
import useToast from '../../../hook/useToast';
import './styles.scss';
import * as BenefitApi from '../../../api/rank/benefitApi';
import ModalDeleteManager from '../../../components/ModalDeleteManager';
import { gold_image, network_operator } from '../../../components/ExportImgFigma';
import { checkDisabledPermission, getUserPermissions } from '../../../until';
import { useSelector } from 'react-redux';
import { selectorPermission } from '../../../store/slices/permissionSlice';
import ShowRank from '../MemberCard/ShowRank';
import viVN from 'antd/locale/vi_VN';
import dayjs from 'dayjs';
import ShowPolicies from '../MemberCard/ShowPolicies';
import useDebounce from '../../../hook/useDebounce';
const { Search } = Input;
const { RangePicker } = DatePicker;

interface DataFilter {
  unitId: number | undefined;
  businessUnitId: number | undefined;
  search: string | undefined;
}

interface IFilter {
  search?: string;
  dateStart: string;
  dateEnd: string;
}

const initFilter: IFilter = {
  search: undefined,
  dateStart: "" as string,
  dateEnd: "" as string,
};

const PolicyManagement: React.FC = () => {
  useEffect(() => {
    document.title = 'THACO AUTO CRM';
  }, []);

  const pushToast = useToast();
  const navigate = useNavigate()
  const permissionSlice = useSelector(selectorPermission)
  const { add, edit, delete: isDelete, upload, download, share, } = getUserPermissions(permissionSlice, location.pathname)

  const [isShowRank, setShowRank] = useState(false)
  const [openDeleteListRank, setOpenDeleteListRank] = useState(false)
  const [dataRank, setDataRank] = useState<RankApi.IRankPolicie[]>([])
  const [dataBenefitRank, setDataBenefitRank] = useState<BenefitApi.IBenefitRank>()
  const [total, setTotal] = useState<number>()

  const [id, setId] = useState<number>()
  const [dataFilter, setDataFilter] = useState<DataFilter>({ unitId: undefined, businessUnitId: undefined, search: undefined })
  const [dataCarePolicie, setDataCarePolicie] = useState<RankApi.IInfoCarePolicie>()

  const [filters, setFilters] = useState<IFilter>(initFilter)



  const getListCarePolicies = useDebounce(async () => {
    const result = await RankApi.getListCarePolicies(1000, 1, dataFilter.search, filters.dateStart, filters.dateEnd);
    if (result?.status) {
      setDataRank(result.data)
      setTotal(result?.total)
    } else {
      pushToast(result?.message, "error", 2000)

    }
  }, 500)

  const gInfoCarePolicie = async (id: number) => {
    const result = await RankApi.getInfoCarePolicie(id);
    if (result?.status) {
      setDataCarePolicie(result.data);
    } else {
      pushToast(result?.message, "error", 2000)

    }
  }
  const handleDelete = async () => {
    if (id) {
      const result = await RankApi.deleteRank(id);
      if (result?.status) {
        getListCarePolicies()
        setOpenDeleteListRank(false)
        pushToast(result?.message, "success", 2000)

      } else {
        pushToast(result?.message, "error", 2000)

      }
    }
  }
  useEffect(() => {
    getListCarePolicies()
  }, [dataFilter, filters.dateStart, filters.dateEnd]);



  return (
    <div className='class-list-page'>
      <Layout>
        <ModalDeleteManager
          isOpen={openDeleteListRank}
          onConfirm={handleDelete}
          closeModal={() => setOpenDeleteListRank(!openDeleteListRank)}
          title="Bạn có chắc chắn xóa chính sách thành viên này"
          titleDelete="Xóa chính sách thành viên"
          content="Chính sách thành viên và dữ liệu liên quan sẽ bị xóa vĩnh viễn
    không thể khôi phục"/>
        <Breadcrumb
          items={[
            {
              title: 'THACO AUTO CRM',
            },
            {
              title: <a href="/">Chương trình KH thành viên</a>,
            },
            {
              title: 'Quản lý chính sách CSKH',
            },
          ]}
        />
        <div className='title-page'>Quản lý chính sách CSKH</div>

        <div
          className={`count-add-rank ${checkDisabledPermission(add)}`}
        >
          <div className="custom-page-css flex items-center gap-4">
            <div className='t-search-block-v3'>
              <Search
                placeholder="Tìm kiếm theo tên"
                value={dataFilter.search}
                onChange={(e) => setDataFilter({ ...dataFilter, search: e.target.value })}
              />
            </div>
            <ConfigProvider locale={viVN}>
              <RangePicker
                className="custom-input-date w-full"
                // open={true}
                placeholder={["Bắt đầu", "Kết thúc"]}
                format="DD/MM/YYYY"
                allowClear
                value={
                  filters.dateStart && filters.dateEnd ?
                    [
                      dayjs(filters.dateStart),
                      dayjs(filters.dateEnd),
                    ] :
                    null
                }
                onCalendarChange={(dates) => {
                  setFilters({
                    ...filters,
                    dateStart: dates?.[0]?.format("YYYY/MM/DD") ?? "",
                    dateEnd: dates?.[1]?.format("YYYY/MM/DD") ?? "",
                  },
                  );
                }}
              />
            </ConfigProvider>
          </div>





          <Link to="/member-card/policy-management/add" className="t-btn-link-icon">
            <div className="icon-svg"><PlusCircleOutlined /></div>
            <div className="text">Thêm mới</div>
          </Link>
        </div>

        <div className="list-rank">
          {dataRank.map((item, index) => (
            <div key={index} className="one-rank">
              <div className="img-box">
                <img
                  src="/bg-rank.svg"
                  alt="bg rank"
                />
              </div>
              <div className="top">
                <div className="icon-name-rank">
                  {/* <div className="icon-svg">
                    <img
                      src={URL_RANK + item.icon}
                      alt="sv"
                      onError={(e) => {
                        e.currentTarget.src = gold_image;
                      }}
                    />
                  </div> */}
                  <div className="name  white-space-nowrap">{item.title}</div>
                </div>
                <div className="list-icon-ctrl">
                  {/* <div
                    className="one-ctrl"
                    onClick={() => navigate('/member-card/class-list/add')}>
                    <CopyOutlined />
                  </div> */}
                  <div
                    className={`one-ctrl ${checkDisabledPermission(edit)}`}
                    onClick={() =>
                      navigate(
                        `/member-card/policy-management/edit`,
                        {
                          state: {
                            id: item.id,
                          }
                        }
                      )
                    }
                  >
                    <EditOutlined />
                  </div>
                  <div className={`one-ctrl ${checkDisabledPermission(edit)}`}
                    onClick={() => { gInfoCarePolicie(item.id); setShowRank(true) }} >
                    <EyeOutlined />
                  </div>
                  <div className={`one-ctrl ${checkDisabledPermission(edit)}`}
                    // onClick={() => { gInfoCarePolicie(item.id); setShowRank(true) }} 

                    onClick={() => {
                      navigate(
                        `/member-card/policy-management/add`,
                        {
                          state: {
                            id: item.id,
                          }
                        }
                      );

                    }}
                  >
                    <CopyOutlined />
                  </div>
                  {/* <div className={`one-ctrl ${checkDisabledPermission(isDelete)}`}
                    onClick={() => { setOpenDeleteListRank(true); setId(item.id) }}
                  >
                    <DeleteOutlined className='text-F5222D' />
                  </div> */}
                </div>
              </div>
              <div className="custom-page-css text-667085 font-regular  ">Mã chính sách: {item.code ?? NO_DATA}</div>
              <div className="custom-page-css text-667085 font-regular  ">Ngày bắt đầu: {item.dateStart ?? NO_DATA}</div>
              <div className="custom-page-css text-667085 font-regular  pb-2">Ngày kết thúc: {item.dateEnd ?? NO_DATA}</div>
              <div className='custom-page-css w-fit flex items-center justify-center rounded border-40A9FF bg-E6F7FF py-1 px-2'>
                <span className='text-xs text-1890FF'>{item.totalBenefitPolicies} quyền lợi chính sách CSKH</span>
              </div>
            </div>
          ))}
        </div>

        {
          isShowRank
            ? <ShowPolicies
              dataCarePolicie={dataCarePolicie}
              className="show"
              onClose={() => { setShowRank(false) }}
            />
            : null
        }

      </Layout>
    </div>
  );
}

export default PolicyManagement;
